import React, {useEffect} from "react"
import Icon from "@mdi/react"
import {mdiFlagVariant} from "@mdi/js"
import {Typography} from "@mui/material"
import {PricingQuoteInfo} from "../../dtos/orderResponse"

interface DiscountProps {
	originalValue: number
	discountedValue: number
	fractionDigits: number
	currency?: string
	pricingQuoteInfo?: PricingQuoteInfo
}

export default function Discount(props: DiscountProps) {
	const [power, setPower] = React.useState(2)
	const [currency, setCurrency] = React.useState("€")

	function getCountry() {
		setPower(props.fractionDigits)
		props.currency ? setCurrency(props.currency) : setCurrency("€")
	}
	useEffect(() => getCountry())

	const value: number = props.originalValue - props.discountedValue
	let floatValue = Number.parseFloat(value.toString())

	let formattedValue = (floatValue / Math.pow(10, power)).toFixed(power)
	const getDiscountPercentage = () => {
		return props.originalValue && props.discountedValue
			? Math.round(((props.originalValue - props.discountedValue) * 100) / props.originalValue)
			: ""
	}

	const mapDiscountSource = (discountSource: string) => {
		let formattedDiscountSource = discountSource
		switch (discountSource) {
			case "UserOverride":
				formattedDiscountSource = "Pricing Override"
				break
		}
		return formattedDiscountSource
	}

	return (
		<Typography>
			<Typography component={"span"} style={{fontWeight: "bold", color: "#1DB051"}}>
				<Icon size="15px" color="#1DB051" path={mdiFlagVariant} /> You Saved{" "}
				{getDiscountPercentage()}% ({currency} {formattedValue})
			</Typography>
			<Typography
				variant="caption"
				style={{fontWeight: "bold", color: "#1DB051", fontSize: "12px"}}
			>
				{props.pricingQuoteInfo &&
					props.pricingQuoteInfo.discountSources &&
					props.pricingQuoteInfo.discountSources.length > 0 &&
					props.pricingQuoteInfo.discountSources.map((discountSource) => {
						if (!discountSource.type)
							return (
								<>
									<br />
									Coupon type not specified
								</>
							)
						return discountSource.type.toLocaleLowerCase() === "coupon" ? (
							<>
								<br />
								Coupon: {discountSource.id}
							</>
						) : (
							<>
								<br />
								Discount Source:{" "}
								{discountSource.type && discountSource.type.toLocaleLowerCase() === "unknown"
									? mapDiscountSource(discountSource.pricingQuoteDiscountType)
									: discountSource.type}
							</>
						)
					})}
			</Typography>
		</Typography>
	)
}
